<template>
  <div>
    <!-- Telegram 登录按钮容器 -->
    <div id="telegram-login" class="telegram-login">
      <slot>
        <!-- <div class="test" v-if="showTele">测试</div> -->
      </slot>
    </div>
  </div>
</template>

<script setup>
import { onMounted, nextTick, ref } from "vue";
import $store from "@/store";
import { showLoading, hideLoading } from '@/components/common/loadingModal/index.js';
const props = defineProps({
  size:{
    type: String,
    default: "medium"
  }
})
const emits = defineEmits(["rendered"]);
//userStore
const u = $store("user");
const showTele = ref(true);
onMounted(() => {
  showLoading();
  console.log("用户id;", u.userInfo.id);
  const userid = u.userInfo.id;
  // 动态加载 Telegram 脚本
  const script = document.createElement("script");
  script.src = "https://telegram.org/js/telegram-widget.js?22";
  script.async = true;

  // 设置 widget 属性
  script.setAttribute("data-telegram-login", "skinroll_bot"); // 替换你的机器人用户名skintest_impayBot
  console.log('size;', props.size);
  script.setAttribute("data-size", props.size);//medium small large
  script.setAttribute("data-radius", "14");
  script.setAttribute(
    "data-auth-url",
    "https://backskins.hotgamer.net/telegram/auth?p=60001&u=" + userid
  ); // 替换你的后端验证URL
  script.setAttribute("data-request-access", "write");

  script.addEventListener("load", () => {
    console.log("脚本加载完毕");
    // emits("rendered");
    const iframe = document.getElementById("telegram-login-skintest_impayBot");
    // emits("rendered");
    // 处理兼容行问题 兼容IE
    if (iframe.attachEvent) {
      iframe.attachEvent("onload", function () {
        // iframe加载完毕以后执行操作
        console.log("iframe已加载完毕");
        showTele.value = false;
        // container.innerHTML = "";
        emits("rendered");
        hideLoading();
      });
    } else {
      iframe.onload = function () {
        // iframe加载完毕以后执行操作
        console.log("iframe已加载完毕");
        showTele.value = false;
        // container.innerHTML = "";
        emits("rendered");
        hideLoading();
      };
    }
  });
  // 将脚本添加到容器中
  const container = document.getElementById("telegram-login");
  container.appendChild(script);
  console.log("tele 渲染完毕");

  nextTick(() => {
    // emits("rendered")
  });
});
// 处理 Telegram 回调（需要与后端配合）
function onTelegramAuth(user) {
  // 发送用户数据到后端验证
  fetch("/api/telegram-login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        // 登录成功处理
        this.$router.push("dashboard");
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// // 监听 Telegram 登录按钮点击事件
// onMounted(() => {
//   const container = document.getElementById("telegram-login");
//   container.addEventListener("click", () => {
//     // 显示 Telegram 登录窗口
//     window.TelegramLogin.showTelegramLogin(onTelegramAuth);
//   });
// });
// // 处理 Telegram 回调
// function onTelegramAuth(user) {
//   // 发送用户数据到后端验证
//   fetch("/api/telegram-login", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(user),
//   })
//     .then((response) => response.json())
//     .then((data) => {
//       if (data.success) {
//         // 登录成功处理
//         this.$emit("teleAuth", user);
//       }
//     })
//     .catch((error) => {
//       console.error("Error:", error);
//     });
// }
</script>

<style scoped lang="scss">
/* 你可以在这里添加一些样式 */
.telegram-login {
  /* 样式代码 */
  // border: 2px solid red;
  // width: 1.72rem;
  // padding-left: .38rem;
  cursor: pointer;
  @extend %flex-all-center;
  justify-content: flex-start;
  // height: .2rem;

  #telegram-login-skintest_impayBot {
  }
}
</style>
